module.exports = __webpack_public_path__ + "src/assets/img/index_tuijian_5.4c3ab746.png";